import { ClaimService } from '@app-core/services';
import { Claim } from '@app-model/api';
import { ClaimsFilter } from '@app-model/claims-filter';

import * as ClaimsActions from './claims.actions';

export interface State {
  claims: Claim[];
  claimsFilter: ClaimsFilter;
  gridClaims: Claim[];
}

const InitialState: State = {
  claims: [],
  claimsFilter: new ClaimsFilter(),
  gridClaims: [],
};

export function reducer(state = InitialState, action: ClaimsActions.All): State {
  switch (action.type) {
    case ClaimsActions.GET_CLAIMS_SUCCESS: {
      return {
        ...state,
        claims: action.payload.claims,
        gridClaims: action.payload.claims,
        claimsFilter: action.payload.filters,
      };
    }

    case ClaimsActions.FILTER_GRID: {
      const gridClaims = ClaimService.filter(action.payload, state.claims);

      return { ...state, claimsFilter: action.payload, gridClaims };
    }

    default: {
      return state;
    }
  }
}
